import { articleContent } from '@/pages/article/page';
import { articles } from '@/mocks/guides';
import { HOME_OG_IMAGE } from './site';

export interface SeoMeta {
  title: string;
  description: string;
  keywords: string;
  canonicalPath: string;
  ogType: 'website' | 'article';
  ogLocale: string;
  ogImage: string;
}

const ARTICLE_SLUG_BY_ROUTE: Record<string, string> = {
  '/cssbuy-spreadsheet/': 'cssbuy-spreadsheet-complete-guide',
  '/cssbuy-review/': 'cssbuy-review-2026',
  '/cssbuy-shipping-cost/': 'cssbuy-shipping-cost-guide',
  '/cssbuy-qc/': 'cssbuy-qc-guide',
  '/cssbuy-warehouse/': 'cssbuy-warehouse-guide',
  '/cssbuy-coupon/': 'cssbuy-coupon-guide',
  '/cssbuy-discount-code/': 'cssbuy-discount-code-guide',
  '/is-cssbuy-legit/': 'is-cssbuy-legit',
  '/cssbuy-fees/': 'cssbuy-fees-guide',
  '/cssbuy-buying-guide/': 'cssbuy-buying-guide',
};

const ARTICLE_IMAGE_BY_SLUG: Record<string, string> = {};
articles.forEach((item) => {
  ARTICLE_IMAGE_BY_SLUG[item.slug] = item.image;
});

const HOME_KEYWORDS =
  'CSSBuy Spreadsheet, CSSBuy, spreadsheet, finds, shipping, QC, coupon, discount code, warehouse, review';

function localeForLang(lang: string): string {
  if (lang === 'de') return 'de_DE';
  if (lang === 'en') return 'en_US';
  return 'pt_BR';
}

export function isArticleRoute(pathname: string): boolean {
  return pathname in ARTICLE_SLUG_BY_ROUTE;
}

export function getArticleSlug(pathname: string): string {
  return ARTICLE_SLUG_BY_ROUTE[pathname];
}

export function getArticleImage(slug: string): string {
  return ARTICLE_IMAGE_BY_SLUG[slug] || HOME_OG_IMAGE;
}

export function resolveSeoMeta(
  pathname: string,
  homeTitle: string,
  homeDesc: string,
  lang: string,
): SeoMeta {
  const slug = ARTICLE_SLUG_BY_ROUTE[pathname];
  if (slug) {
    const article = articleContent[slug];
    const keywords = `CSSBuy Spreadsheet, CSSBuy, ${article.category.toLowerCase()}, guide, shipping, QC`;
    return {
      title: article.metaTitle,
      description: article.metaDesc,
      keywords,
      canonicalPath: pathname,
      ogType: 'article',
      ogLocale: localeForLang(lang),
      ogImage: getArticleImage(slug),
    };
  }

  return {
    title: homeTitle,
    description: homeDesc,
    keywords: HOME_KEYWORDS,
    canonicalPath: pathname,
    ogType: 'website',
    ogLocale: localeForLang(lang),
    ogImage: HOME_OG_IMAGE,
  };
}